<tx-loader *ngIf="loadingService.loading" [loadingAction]="loadingService.loadingAction"></tx-loader>

<h4 class="mb-4">Upload document</h4>

<div class="fileUploadWrapper mb-4">
  <form>
    <div class="fileupload" txDragDropFileUpload (click)="fileField.click()" (fileDropped)="selectFile($event)">
      <i class="bi bi-cloud-arrow-up fs-2 text-secondary"></i>
      <span class="text-secondary">
        Choose a file or drag here
        <i class="bi-info-circle" [title]="getTooltipMessage()"></i>
      </span>
      <input
        type="file"
        name="upload-file-field"
        #fileField
        (change)="selectFile($any($event).target.files)"
        hidden
        [accept]="acceptedFormat" />
    </div>
  </form>
</div>

<ng-container *ngIf="document.document != null">
  <div class="mb-4 d-flex align-items-center gap-3">
    <label>
      Upload '
      <strong>{{ document.filename }}</strong>
      ' to case:
    </label>

    <div class="flex-fill">
      <tx-client-case-tree
        [preselectedCaseId]="preselectedCaseId"
        [preselectedContactId]="preselectedContactId"
        (caseSelected)="onCaseSelected($event)"></tx-client-case-tree>
    </div>
  </div>
  <button type="button" class="btn btn-primary" (click)="onUploadClicked()" [hidden]="document.casID == null">
    Upload
  </button>
</ng-container>

<form
  ngNoForm
  [action]="submitUrl"
  method="post"
  enctype="application/x-www-form-urlencoded"
  target="_blank"
  #openInNewTabForm>
  <input type="hidden" id="dcmID" name="dcmID" />
  <input type="hidden" [id]="sessionId" [name]="sessionId" />
</form>
